/* ═══════════════════════════════════════
   ESSIG WILLERT – base.js
   ═══════════════════════════════════════ */

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

// Erkennen, ob die Seite neu geladen wurde (Reload / erneutes Aufrufen derselben URL)
var willertIsReload = false;
try {
  var navEntries = performance.getEntriesByType('navigation');
  if (navEntries.length) {
    willertIsReload = navEntries[0].type === 'reload';
  } else if (performance.navigation) {
    willertIsReload = performance.navigation.type === 1;
  }
} catch (e) {}

if (willertIsReload || !window.location.hash) {
  // Beim Neuladen einen evtl. vorhandenen Anker aus der URL entfernen, damit man oben startet
  if (willertIsReload && window.location.hash) {
    history.replaceState(null, '', window.location.pathname + window.location.search);
  }
  window.scrollTo(0, 0);
  window.addEventListener('load', () => {
    window.scrollTo(0, 0);
    setTimeout(() => window.scrollTo(0, 0), 50);
    setTimeout(() => window.scrollTo(0, 0), 150);
  });
} else {
  window.addEventListener('load', () => {
    var el = document.querySelector(window.location.hash);
    if (el) setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 300);
  });
}

document.addEventListener('DOMContentLoaded', function () {

  if (!window.location.hash) window.scrollTo(0, 0);

  // ScrollTrigger mit normalem Scroll synchronisieren
  ScrollTrigger.normalizeScroll(false);
  gsap.ticker.lagSmoothing(0);

  // ─── PROGRESS BAR ────────────────────────
  const pb = document.getElementById('progress-bar');
  if (pb) {
    gsap.to(pb, { scaleX: 1, ease: 'none', scrollTrigger: { scrub: 0.3, start: 'top top', end: 'bottom bottom' } });
  }

  // ─── LOADER ──────────────────────────────
  const loader = document.getElementById('loader');
  if (loader) {
    const loaderTl = gsap.timeline({ onComplete: startAnimations });
    loaderTl
      .to('#loader-text',  { y: 0, opacity: 1, duration: .8, ease: 'expo.out' })
      .to('#loader-sub',   { opacity: 1, duration: .5 }, '-=.3')
      .to('#loader-bar',   { left: '0%', duration: 1.4, ease: 'expo.inOut' }, '-=.2')
      .to('#loader-num',   {
        innerText: 100,
        snap: { innerText: 1 },
        duration: 1.4,
        ease: 'expo.inOut',
        onUpdate: function () {
          const n = document.getElementById('loader-num');
          if (n) n.textContent = Math.round(parseFloat(n.innerText || 0)) + '%';
        }
      }, '<')
      .to('#loader', { yPercent: -100, duration: .8, ease: 'expo.inOut', delay: .2 })
      .set('#loader', { display: 'none' });
  } else {
    startAnimations();
  }

  function startAnimations() {
    gsap.registerPlugin(ScrollTrigger);

    // NAV IN
    gsap.to(['#navLogo','#navLinks','.nav-actions'], { opacity: 1, y: 0, duration: .8, stagger: .12, ease: 'expo.out' });

    // HERO
    gsap.fromTo('#heroBadge', { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: .8, ease: 'expo.out', delay: .1 });

    // Hero title – char by char
    document.querySelectorAll('.hero-title .line').forEach((line, i) => {
      const text = line.innerHTML;
      const isItalic = line.querySelector('em');
      if (!isItalic) {
        line.innerHTML = text.split('').map(c => c === ' ' ? ' ' : `<span style="display:inline-block;overflow:hidden"><span class="char">${c}</span></span>`).join('');
      } else {
        const em = line.querySelector('em');
        const emText = em ? em.textContent : '';
        em.innerHTML = emText.split('').map(c => c === ' ' ? ' ' : `<span style="display:inline-block"><span class="char">${c}</span></span>`).join('');
      }
      gsap.from(line.querySelectorAll('.char'), {
        yPercent: 120, opacity: 0, duration: .9,
        stagger: .03, ease: 'expo.out', delay: .25 + i * .1
      });
    });

    gsap.from('.hero-desc',    { opacity: 0, y: 24, duration: .8, delay: .55, ease: 'expo.out' });
    gsap.from('.hero-actions', { opacity: 0, y: 24, duration: .8, delay: .7,  ease: 'expo.out' });

    // JARS IN
    gsap.set(['#jar1','#jar2','#jar3','#jar4'], { opacity: 0, y: 60 });
    gsap.to(['#jar1','#jar3','#jar2','#jar4'], { opacity: 1, y: 0, duration: 1.2, stagger: .15, ease: 'expo.out', delay: .4 });

    // JAR FLOAT LOOP
    ['#jar1','#jar2','#jar3','#jar4'].forEach((id, i) => {
      if (!document.querySelector(id)) return;
      gsap.to(id, { y: `${-22 - i*5}px`, rotation: `${(i%2===0?1.5:-1.5)*2}`, duration: 2.2+i*.5, ease:'sine.inOut', yoyo:true, repeat:-1, delay:i*.35 });
    });

    // SPARKLES
    const sparkles = document.getElementById('sparkles');
    if (sparkles) {
      for (let i = 0; i < 18; i++) {
        const s = document.createElement('div');
        s.style.cssText = `position:absolute;width:4px;height:4px;border-radius:50%;background:var(--gold);opacity:0;left:${20+Math.random()*300}px;top:${20+Math.random()*400}px;pointer-events:none;`;
        sparkles.appendChild(s);
        gsap.to(s, { opacity:Math.random()*.7+.2, scale:Math.random()*1.5+.5, y:-(Math.random()*30+10), duration:1.5+Math.random()*2, delay:Math.random()*3, yoyo:true, repeat:-1, ease:'sine.inOut' });
      }
    }

    // HERO BG PARALLAX
    if (document.querySelector('#hero .hero-bg img')) {
      gsap.to('#hero .hero-bg img', { yPercent: 25, ease:'none', scrollTrigger:{ trigger:'#hero', start:'top top', end:'bottom top', scrub:true } });
    }

    // BLOBS
    gsap.to('.blob-1', { x:80,  y:60,  duration:8,  yoyo:true, repeat:-1, ease:'sine.inOut' });
    gsap.to('.blob-2', { x:-60, y:-40, duration:10, yoyo:true, repeat:-1, ease:'sine.inOut', delay:1 });
    gsap.to('.blob-3', { x:50,  y:80,  duration:7,  yoyo:true, repeat:-1, ease:'sine.inOut', delay:2 });

    // NAV SCROLL
    const nav = document.getElementById('nav');
    ScrollTrigger.create({ start: 80, onEnter: () => nav && nav.classList.add('scrolled'), onLeaveBack: () => nav && nav.classList.remove('scrolled') });

    // ABOUT
    gsap.from('#aboutImg', { xPercent:-8, opacity:0, duration:1.2, ease:'expo.out', scrollTrigger:{ trigger:'#ueber-uns', start:'top 75%' } });
    gsap.from('#aboutFloat', { scale:.8, opacity:0, duration:1, ease:'expo.out', delay:.3, scrollTrigger:{ trigger:'#ueber-uns', start:'top 75%' } });
    gsap.from('#aboutBadge', { xPercent:-40, opacity:0, duration:.9, ease:'expo.out', delay:.5, scrollTrigger:{ trigger:'#ueber-uns', start:'top 75%' } });
    gsap.from('#aboutImg img', { scale:1.15, ease:'none', scrollTrigger:{ trigger:'#aboutImg', start:'top bottom', end:'bottom top', scrub:true } });
    gsap.from(['#aboutTag','#aboutH','#aboutDiv','#aboutP1','#aboutP2','#aboutStats'], { opacity:0, y:32, duration:.8, stagger:.12, ease:'expo.out', scrollTrigger:{ trigger:'#ueber-uns', start:'top 70%' } });

    // STAT COUNTERS
    document.querySelectorAll('.stat-num').forEach(el => {
      const target = +(el.dataset.target || 0);
      const suffix = el.dataset.suffix || '';
      gsap.to({ val: 0 }, {
        val: target, duration: 1.8, ease: 'expo.out',
        onUpdate: function () { el.textContent = Math.round(this.targets()[0].val) + suffix; },
        scrollTrigger: { trigger: el, start: 'top 85%' }
      });
    });

    // PRODUCTS
    gsap.from('.prod-header', { opacity:0, y:40, duration:1, ease:'expo.out', scrollTrigger:{ trigger:'#produkte', start:'top 80%' } });
    gsap.from('.prod-card', { opacity:0, y:60, duration:.9, stagger:.12, ease:'expo.out', scrollTrigger:{ trigger:'.prod-grid', start:'top 80%' } });

    // 3D TILT
    document.querySelectorAll('.prod-card').forEach(card => {
      card.addEventListener('mousemove', e => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width  - .5;
        const y = (e.clientY - r.top)  / r.height - .5;
        gsap.to(card, { rotateY:x*12, rotateX:-y*12, duration:.4, ease:'expo.out', transformPerspective:800 });
      });
      card.addEventListener('mouseleave', () => gsap.to(card, { rotateY:0, rotateX:0, duration:.6, ease:'expo.out' }));
    });

    // DETAIL
    gsap.from(['.detail-tabs','.detail-wrap'], { opacity:0, y:40, duration:.9, stagger:.15, ease:'expo.out', scrollTrigger:{ trigger:'#produkt-detail', start:'top 75%' } });

    // TIMELINE
    gsap.from('.tl-item', { opacity:0, x:(i)=>i%2===0?-50:50, duration:.9, stagger:.15, ease:'expo.out', scrollTrigger:{ trigger:'.tl', start:'top 80%' } });

    // B2B
    gsap.from('.b2b-wrap > div:first-child', { xPercent:-6, opacity:0, duration:1.1, ease:'expo.out', scrollTrigger:{ trigger:'#gastronomie', start:'top 75%' } });
    gsap.from('.b2b-wrap > div:last-child > *', { opacity:0, y:30, duration:.8, stagger:.1, ease:'expo.out', scrollTrigger:{ trigger:'#gastronomie', start:'top 70%' } });
    gsap.from('.b2b-prod', { opacity:0, x:32, duration:.7, stagger:.12, ease:'expo.out', scrollTrigger:{ trigger:'.b2b-products', start:'top 80%' } });

    // QUALITY
    gsap.from('.qual-card', { opacity:0, y:50, duration:.8, stagger:.1, ease:'expo.out', scrollTrigger:{ trigger:'.qual-grid', start:'top 80%' } });

    // HÄNDLER
    gsap.from('.haendler-map', { opacity:0, xPercent:-5, duration:1, ease:'expo.out', scrollTrigger:{ trigger:'#haendler', start:'top 75%' } });
    gsap.from('.haendler-item', { opacity:0, x:30, duration:.7, stagger:.1, ease:'expo.out', scrollTrigger:{ trigger:'.haendler-items', start:'top 80%' } });

    // KONTAKT
    gsap.from('.kontakt-wrap > div:first-child > *', { opacity:0, y:30, duration:.8, stagger:.1, ease:'expo.out', scrollTrigger:{ trigger:'#kontakt', start:'top 70%' } });
    gsap.from('.kontakt-form', { opacity:0, x:60, duration:1, ease:'expo.out', scrollTrigger:{ trigger:'#kontakt', start:'top 70%' } });

    // FOOTER
    gsap.from('.footer-grid > *', { opacity:0, y:30, duration:.8, stagger:.12, ease:'expo.out', scrollTrigger:{ trigger:'footer', start:'top 85%' } });

    // SCROLL HINT
    gsap.to('#scrollHint', { opacity:0, y:20, scrollTrigger:{ trigger:'#hero', start:'30% top', end:'50% top', scrub:true } });

    // MARQUEE
    const track = document.getElementById('mTrack');
    if (track) {
      gsap.to(track, { x:'-50%', duration:28, ease:'none', repeat:-1, modifiers:{ x: gsap.utils.unitize(x => parseFloat(x) % (track.scrollWidth / 2)) } });
    }

    // MAGNETIC BUTTONS
    document.querySelectorAll('.btn-gold,.btn-ghost,.nav-cta').forEach(btn => {
      btn.addEventListener('mousemove', e => {
        const r = btn.getBoundingClientRect();
        const x = (e.clientX - r.left - r.width/2)  * .25;
        const y = (e.clientY - r.top  - r.height/2) * .25;
        gsap.to(btn, { x, y, duration:.3, ease:'expo.out' });
      });
      btn.addEventListener('mouseleave', () => gsap.to(btn, { x:0, y:0, duration:.5, ease:'elastic.out(1,.4)' }));
    });
  }

  // ─── TABS ────────────────────────────────
  window.switchTab = function(id, el) {
    document.querySelectorAll('.detail-panel').forEach(p => p.classList.remove('active'));
    document.querySelectorAll('.detail-tab').forEach(t => t.classList.remove('active'));
    const panel = document.getElementById('panel-' + id);
    if (panel) panel.classList.add('active');
    if (el) {
      el.classList.add('active');
    } else {
      const map = { senf:0, essig:1, tunke:2, fix:3 };
      const tabs = document.querySelectorAll('.detail-tab');
      if (map[id] !== undefined && tabs[map[id]]) tabs[map[id]].classList.add('active');
    }
    if (panel) {
      gsap.from(panel.querySelectorAll('.detail-wrap > *'), { opacity:0, y:24, duration:.6, stagger:.1, ease:'expo.out' });
    }
  };

  // SIZE SELECTOR
  document.querySelectorAll('.detail-sizes').forEach(wrap => {
    wrap.querySelectorAll('.dsize').forEach(btn => {
      btn.addEventListener('click', () => {
        wrap.querySelectorAll('.dsize').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        gsap.from(btn, { scale:.9, duration:.3, ease:'back.out' });
      });
    });
  });

  // MOBILE NAV
  const burger = document.getElementById('burger');
  const navEl = document.getElementById('nav');
  if (burger && navEl) {
    burger.addEventListener('click', () => navEl.classList.toggle('open'));
    document.querySelectorAll('.nav-links a').forEach(a => a.addEventListener('click', () => navEl.classList.remove('open')));
  }

  // FORM
  const forms = document.querySelectorAll('#ContactForm, form[id="ContactForm"]');
  forms.forEach(form => {
    form.addEventListener('submit', function(e) {
      const btn = form.querySelector('.form-submit, [type="submit"]');
      if (!btn) return;
      gsap.to(btn, { scale:.97, duration:.1, yoyo:true, repeat:1 });
    });
  });

});
